<script setup>
import { useSlots } from 'vue';
import BackButton from '../../../../components/widgets/BackButton.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  backButtonLabel: {
    type: String,
    default: '',
  },
  searchPlaceholder: {
    type: String,
    default: '',
  },
  // O selo do topo. Cada tela de Configuracoes passa o seu; a engrenagem e o
  // padrao para as que ainda nao escolheram.
  icone: {
    type: String,
    default: 'i-lucide-settings',
  },
});

// `link-text` e `feature-name` levavam à ajuda do Chatwoot; o link saiu em
// 07/10/2026 e as telas que ainda passam os dois não devem virar atributo.
defineOptions({ inheritAttrs: false });

const slots = useSlots();

const searchQuery = defineModel('searchQuery', { type: String, default: '' });
</script>

<template>
  <div class="flex flex-col items-start w-full gap-2">
    <BackButton
      v-if="backButtonLabel"
      compact
      :button-label="backButtonLabel"
      class="my-1"
    />
    <!-- A faixa azul das telas v2 (07/10/2026): Configurações era a única
         área do dia a dia com título solto sobre fundo branco. A descrição
         vira a frase da faixa e pode ocupar duas linhas — aqui ela explica
         a tela, não é só um lembrete. -->
    <header
      v-if="title"
      class="advup-faixa advup-faixa--heroi advup-entra cfg-faixa w-full"
    >
      <div class="advup-faixa__id">
        <span class="advup-marca" aria-hidden="true">
          <i :class="icone" />
        </span>
        <div class="min-w-0">
          <h1 class="advup-faixa__tit">{{ title }}</h1>
          <p v-if="description || $slots.description" class="advup-faixa__sub">
            <slot name="description">{{ description }}</slot>
          </p>
        </div>
      </div>
    </header>
  </div>
  <div
    v-if="searchPlaceholder || slots.actions || slots.tabs"
    class="gap-3 flex justify-between sm:mt-4 min-w-0"
  >
    <div
      v-if="slots.tabs || searchPlaceholder"
      class="flex items-center gap-3"
      :class="{
        'hidden sm:flex': !slots.tabs,
      }"
    >
      <slot name="tabs" />
      <!-- Casca de busca do produto, a mesma de Casos, Publicacoes,
           Disparos e Contatos. A anterior precisava de quatro ajustes de
           classe para caber, e mesmo assim tinha outra altura e outro raio
           das buscas do resto do sistema. -->
      <div
        v-if="searchPlaceholder"
        class="advup-busca advup-busca--curta hidden sm:flex"
      >
        <i class="advup-busca__lupa i-lucide-search" aria-hidden="true" />
        <input
          v-model="searchQuery"
          type="search"
          class="advup-busca__campo reset-base"
          :placeholder="searchPlaceholder"
        />
      </div>
    </div>
    <div
      class="flex items-center gap-3 min-w-0"
      :class="{ 'flex-row-reverse sm:flex-row': !slots.tabs }"
    >
      <slot name="count" />
      <div
        v-if="slots.count"
        class="w-px h-3 rounded-lg bg-n-weak ltr:ml-1 ltr:mr-2 rtl:ml-2 rtl:mr-1 flex-shrink-0"
      />
      <slot name="actions" />
    </div>
  </div>
</template>

<style scoped>
/* A descrição das Configurações explica a tela: duas linhas, não reticências. */
.cfg-faixa .advup-faixa__sub {
  display: -webkit-box;
  max-width: 78ch;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

@media (max-width: 639px) {
  .cfg-faixa .advup-faixa__sub {
    -webkit-line-clamp: 3;
  }
}
</style>
